import { hasWindow } from "@omni/utils/dom.utils";
import { isDefined } from "@omni/utils/helper.utils";

import { WindowEvent } from "@/services/windowEvents/windowEvent.service";
import { Config } from "@/utils/config.utils";

const oneTrustLoaded = new Promise<void>((resolve) => {
    if (!hasWindow()) return;

    if (!isDefined(window.OneTrust)) {
        window.addEventListener(WindowEvent.OneTrustLoaded, () => resolve());
    } else {
        resolve();
    }
});

const isCategoryEnabled = async (category: CookieCategory) => {
    if (!Config.general.author) {
        await oneTrustLoaded;
    }

    return (window.OnetrustActiveGroups || "").includes(category);
};

export enum CookieCategory {
    Strict = "C0001",
    Performance = "C0002",
    Functional = "C0003",
    Targeting = "C0004",
    SocialMedia = "C0005"
}

export const handleOnConsentChanged = async (
    consentChangedHandler: () => void
) => {
    await oneTrustLoaded;

    window.OneTrust?.OnConsentChanged(consentChangedHandler);
};

export const isStrictCookiesEnabled = async () => {
    return isCategoryEnabled(CookieCategory.Strict);
};

export const isPerformanceCookiesEnabled = async () => {
    return isCategoryEnabled(CookieCategory.Performance);
};

export const isFunctionalCookiesEnabled = async () => {
    return isCategoryEnabled(CookieCategory.Functional);
};

export const isTargetingCookiesEnabled = async () => {
    return isCategoryEnabled(CookieCategory.Targeting);
};

export const isSocialMediaCookiesEnabled = async () => {
    return isCategoryEnabled(CookieCategory.SocialMedia);
};

export const isOnlyStrictCookiesEnabled = async () => {
    return !(
        (await isPerformanceCookiesEnabled()) ||
        (await isFunctionalCookiesEnabled()) ||
        (await isTargetingCookiesEnabled()) ||
        (await isSocialMediaCookiesEnabled())
    );
};
